module.exports = __webpack_public_path__ + "img/symbol-x2-right.e5739ba3.png";